import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgNurseFemale1 = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.1584 6.495C16.4338 7.15971 16.5411 7.88212 16.4707 8.5982C16.4003 9.31429 16.1543 10.0019 15.7546 10.6003C15.3549 11.1986 14.8138 11.6891 14.1792 12.0283C13.5447 12.3675 12.8362 12.545 12.1167 12.545C11.3972 12.545 10.6887 12.3675 10.0542 12.0283C9.4196 11.6891 8.8785 11.1986 8.4788 10.6003C8.0791 10.0019 7.83314 9.31429 7.76271 8.5982C7.69228 7.88212 7.79956 7.15971 8.07503 6.495"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.74 21.375V14.4442"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.73999 18.7942H10.24"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98999 17.5442V20.0442"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.24 4.5C10.24 4.74623 10.2885 4.99005 10.3827 5.21753C10.4769 5.44502 10.6151 5.65172 10.7892 5.82582C10.9633 5.99993 11.17 6.13805 11.3975 6.23227C11.6249 6.3265 11.8688 6.375 12.115 6.375C12.3612 6.375 12.605 6.3265 12.8325 6.23227C13.06 6.13805 13.2667 5.99993 13.4408 5.82582C13.6149 5.65172 13.753 5.44502 13.8473 5.21753C13.9415 4.99005 13.99 4.74623 13.99 4.5C13.99 4.25377 13.9415 4.00995 13.8473 3.78247C13.753 3.55498 13.6149 3.34828 13.4408 3.17417C13.2667 3.00006 13.06 2.86195 12.8325 2.76773C12.605 2.6735 12.3612 2.625 12.115 2.625C11.8688 2.625 11.6249 2.6735 11.3975 2.76773C11.17 2.86195 10.9633 3.00006 10.7892 3.17417C10.6151 3.34828 10.4769 3.55498 10.3827 3.78247C10.2885 4.00995 10.24 4.25377 10.24 4.5V4.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.78418 8.25H16.4458"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.1467 21.375C19.8678 19.4438 18.9024 17.6777 17.4273 16.4004C15.9522 15.1231 14.0663 14.42 12.115 14.42C10.1638 14.42 8.27786 15.1231 6.80279 16.4004C5.32772 17.6777 4.36229 19.4438 4.08337 21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.73999 8.25C7.73999 8.25 7.73999 11.375 5.23999 12.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.49 8.25C16.49 8.25 16.49 11.375 18.99 12.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgNurseFemale1.displayName = 'SvgNurseFemale1';
export default SvgNurseFemale1;
